import { useNode } from "@craftjs/core";
import React from "react";
import { isUpdatedFromDefault } from "../../utils";

import {
  CenterAlignActiveIcon,
  CenterAlignIcon,
  JustifyActiveIcon,
  JustifyIcon,
  LeftALignActiveIcon,
  LeftALignIcon,
  RightAlignActiveIcon,
  RightAlignIcon,
  PencilActiveIcon,
} from "../../../assets/ui-icons";

import {
  OptionsInput,
  RangeInput,
  SpacerInput,
  ToggleInput,
  TextInput,
  MultiSelectInput,
  SelectInput,
  Tabs,
  FormatOptionsInput,
} from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo, faWindowRestore } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSVideoSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    title,
    muted = false,
    autoplay = false,
    showControls = true,
    controlsList,
    poster,
    preload,
    loop,
    disablePictureInPicture,
    width,
    height,
    align,
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <RangeInput
            label="Height"
            value={height}
            min={INPUT_LIMITS["cms-video-width-height"].min}
            max={INPUT_LIMITS["cms-video-width-height"].max}
            step={INPUT_LIMITS["cms-video-width-height"].step}
            onChange={(val) => {
              setProp((props) => {
                props.height = val + "px";
                return props;
              });
            }}
            // min={10}
            // max={1000}
          />
          <RangeInput
            label="Width"
            value={width}
            min={INPUT_LIMITS["cms-video-width-height"].min}
            max={INPUT_LIMITS["cms-video-width-height"].max}
            step={INPUT_LIMITS["cms-video-width-height"].step}
            onChange={(val) => {
              setProp((props) => {
                props.width = val + "%";
                return props;
              });
            }}
            // min={10}
            // max={1000}
          />
          <ToggleInput
            label="Muted"
            value={muted}
            onChange={(val) => {
              setProp((props) => {
                props.muted = val;
              });
            }}
          />
          <ToggleInput
            label="Autoplay"
            value={autoplay}
            onChange={(val) => {
              setProp((props) => {
                props.autoplay = val;
              });
            }}
          />
          <ToggleInput
            label="Show Controls"
            value={showControls}
            onChange={(val) => {
              setProp((props) => {
                props.showControls = val;
              });
            }}
          />{" "}
          <ToggleInput
            label="Loop"
            value={loop}
            onChange={(val) => {
              setProp((props) => {
                props.loop = val;
              });
            }}
          />{" "}
          <ToggleInput
            label="Disable Picture In Picture"
            value={disablePictureInPicture}
            onChange={(val) => {
              setProp((props) => {
                props.disablePictureInPicture = val;
              });
            }}
          />
          <SelectInput
            label={"Preload"}
            value={preload}
            onChange={(val) => {
              setProp((props) => {
                props.preload = val;
              });
            }}
            options={[
              {
                label: "None",
                value: "none",
              },
              {
                label: "Metadata",
                value: "metadata",
              },
              {
                label: "Auto",
                value: "auto",
              },
            ]}
          />
          <MultiSelectInput
            label={"Controls List"}
            value={controlsList}
            onChange={(val) => {
              setProp((props) => {
                props.controlsList = val;
              });
            }}
            options={[
              {
                label: "No Full Screen",
                value: "nofullscreen",
              },
              {
                label: "No Download",
                value: "nodownload",
              },
              {
                label: "No Remote Playback",
                value: "noremoteplayback",
              },
              {
                label: "No Playback Rate",
                value: "noplaybackrate",
              },
              {
                label: "Foobar",
                value: "foobar",
              },
            ]}
          />
          <TextInput
            minLength={INPUT_LIMITS["video-poster"].minlength}
            maxLength={INPUT_LIMITS["video-poster"].maxlength}
            label="Poster"
            value={poster}
            onChange={(val) => {
              setProp((props) => {
                props.poster = val.target.value;
              });
            }}
          />
          <TextInput
            minLength={INPUT_LIMITS["video-title"].minlength}
            maxLength={INPUT_LIMITS["video-title"].maxlength}
            label="Title"
            value={title}
            onChange={(val) => {
              setProp((props) => {
                props.title = val.target.value;
              });
            }}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Justify",
                value: "space-between",
                icon: <JustifyIcon width={"20px"} />,
                active: <JustifyActiveIcon width={"20px"} />,
              },
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
          <FormatOptionsInput label={"Font Style"} />
        </SpacerInput>
      </>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 cursor-default overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between gap-3">
          <RightBar title={"Video"} icon={<FontAwesomeIcon icon={faVideo} />} />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
